export default __webpack_public_path__ + "static/media/mettmann_light.8498b063.png";